const TRACK = {
  enableOutput: false
}

;['debug', 'error', 'info', 'log', 'warn'].forEach(method => {
  TRACK[method] = function () {
    if (TRACK.enableOutput) {
      return console[method].apply(console, arguments)
    }
  }
})

/**
 * A `console` wrapper that can be enabled or disabled. Mostly used
 * for suppressing logs in production environments
 *
 * @example
 * import { track } from '@cwp/utils'
 *
 * // enable output
 * track.enableOutput = true
 *
 * track.log('Hey world')
 */
export default TRACK
